import { Page, SliderToggle } from "@dust-tt/sparkle";
import { useTranslation } from "react-i18next";

interface RestrictedAccessHeaderProps {
  isRestricted: boolean;
  onToggle: () => void;
  restrictedDescription: string;
  unrestrictedDescription: string;
}

export function RestrictedAccessHeader({
  isRestricted,
  onToggle,
  restrictedDescription,
  unrestrictedDescription,
}: RestrictedAccessHeaderProps) {
  const { t } = useTranslation();
  return (
    <>
      <div className="flex w-full items-center justify-between overflow-visible">
        <Page.SectionHeader
          title={t("spaces.restrictedAccessSectionHeader", "Restricted Access")}
        />
        <SliderToggle selected={isRestricted} onClick={onToggle} />
      </div>
      {isRestricted ? (
        <span>{restrictedDescription}</span>
      ) : (
        <span>{unrestrictedDescription}</span>
      )}
    </>
  );
}
